import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import * as moment from 'moment'
import 'moment-timezone';
import { NgxSpinnerService } from "ngx-spinner";

import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
    selector: 'app-compare',
    templateUrl: './compare.component.html',
    styleUrls: ['./compare.component.css']
})
export class CompareComponent implements OnInit {

    public project_id: any = {};
    public projects = [];
    public compare = [];
    public total_per_sm: any = {};
    public session_data: any = {};
    public err: any = {};
    public result: any = {};
    public sentiment = 0;
    public country = '';
    public text_search = '';
    public checked_sm: any = { all: true, twitter: false, facebook: false, instagram: false, web: false, youtube: false, reviews: false, others: false, linkedin: false, reddit: false };
    public pie_percentage: any = { twitter: 0, facebook: 0, instagram: 0, web: 0, youtube: 0, reviews: 0, others: 0, reddit: 0, linkedin: 0 };

    public mmapLoading = false;

    public lineChartData = [];
    public ChartDataSets = [];
    public lineChartLabels = [];
    public lineChartLegend = true;
    public lineChartType = 'line';
    public lineChartPlugins = [];
    public lineChartColors = ['#4392B7', '#37A9F3', '#F7C050', '#4867AA', '#FF4A4A', '#038c99', '#f47424'];
    public lineChartOptions: (ChartOptions & { annotation: any }) = {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: true, position: 'bottom' },
        scales: {
            yAxes: [
                {
                    ticks: {
                        maxTicksLimit: 8
                    }
                }
            ],
            xAxes: [
                {
                    type: 'time',
                    distribution: 'series',
                    time: {
                        tooltipFormat: 'DD MMM',
                        displayFormats: {
                            'millisecond': '',
                            'second': 'DD MMM',
                            'minute': 'DD MMM',
                            'hour': 'DD MMM',
                            'day': 'DD MMM',
                            'week': 'DD MMM',
                            'month': 'DD MMM',
                            'quarter': 'DD MMM',
                            'year': 'DD MMM',
                        }
                    }
                },
            ]
        },
        annotation: {},
    };

    public selected: any = {};
    alwaysShowCalendars: boolean;
    showRangeLabelOnInput: boolean;
    keepCalendarOpeningWithRange: boolean;
    ranges: any = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [
            moment()
                .subtract(1, 'month')
                .startOf('month'),
            moment()
                .subtract(1, 'month')
                .endOf('month')
        ],
        'Last 3 Month': [
            moment()
                .subtract(3, 'month')
                .startOf('month'),
            moment()
                .subtract(1, 'month')
                .endOf('month')
        ]
    };

    public sentimentDoughnutChartLabels: Label[] = ['Positive', 'Negative'];
    public sentimentDoughnutChartColors: Array<any> = [{
        backgroundColor: ['green', 'red'],
    }];
    public sentimentDoughnutChartOptions: any = {
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    var dataset = data.datasets[tooltipItem.datasetIndex];
                    var label = data.labels[tooltipItem.index];
                    var total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                        return parseInt(previousValue) + parseInt(currentValue);
                    });
                    var currentValue = dataset.data[tooltipItem.index];
                    var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
                    return label + ': ' + percentage + "%";
                }
            }
        },
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                fontSize: 10,
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        return data.labels.map(function(label, i) {
                            var ds = data.datasets[0];
                            var color = ds.backgroundColor[i];
                            var total = ds.data.reduce((a, b) => parseInt(a) + parseInt(b), 0);
                            var percentage = Math.floor(((ds.data[i] / total) * 100) + 0.5);
                            return { text: percentage + "% " + label, fillStyle: color };
                        });
                    }
                }
            }
        }
    };
    public sourcesDoughnutChart = [];

    public doughnutChartLabels: Label[] = ['Web', 'Twitter', 'Instagram', 'Facebook', 'Youtube', 'Reviews', 'Linkedin', 'Others'];
    public doughnutChartColors: Array<any> = [{
        backgroundColor: ['#4392B7', '#37A9F3', '#F7C050', '#4867AA', '#FF4A4A', '#038c99', '#0077b5', '#FF4500'],
    }];

    public doughnutChartOptions: any = {
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    var dataset = data.datasets[tooltipItem.datasetIndex];
                    var label = data.labels[tooltipItem.index];
                    var total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                        return parseInt(previousValue) + parseInt(currentValue);
                    });
                    var currentValue = dataset.data[tooltipItem.index];
                    var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
                    return label + ': ' + percentage + "%";
                }
            }
        },
        legend: {
            display: true,
            position: 'right',
            labels: {
                fontSize: 10,
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        return data.labels.map(function(label, i) {
                            var ds = data.datasets[0];
                            var color = ds.backgroundColor[i];
                            var total = ds.data.reduce((a, b) => parseInt(a) + parseInt(b), 0);
                            var percentage = Math.floor(((ds.data[i] / total) * 100) + 0.5);
                            return { text: percentage + "% " + label, fillStyle: color };
                        });
                    }
                }
            }
        }
    };
    public doughnutChartData = [];
    public doughnutChartLegend = true;
    public doughnutChartType: ChartType = 'doughnut';

    constructor(private router: Router, private service: DashboardService, private login: LoginService, private route: ActivatedRoute, private spinner: NgxSpinnerService) {
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.service.setTitle('Comparision | 24ieye');
        this.project_id = this.route.snapshot.queryParams["id"];
        this.compare = [this.route.snapshot.queryParams["id"]];
        this.alwaysShowCalendars = true;
        this.keepCalendarOpeningWithRange = true;
        this.get_projects();
        this.selected = { startDate: login.get_session_data('ieye_session_start_date'), endDate: login.get_session_data('ieye_session_end_date') };
    }

    ngOnInit(): void {
        this.compare.forEach((project_id, index) => {
            this.get_mentions_graph(this.selected.startDate, this.selected.endDate, project_id);
            this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate, project_id);
        });
    }

    datesUpdated(range) {
        this.ChartDataSets = [];
        this.sourcesDoughnutChart = [];
        if (range.startDate != null && range.endDate != null) {
            this.service.saveDateRange(moment(range.startDate._d).format("YYYY-MM-DD"), moment(range.endDate._d).format("YYYY-MM-DD"));
            this.selected = { startDate: this.login.get_session_data('ieye_session_start_date'), endDate: this.login.get_session_data('ieye_session_end_date') };
            this.compare.forEach((project_id, index) => {
                this.get_mentions_graph(this.selected.startDate, this.selected.endDate, project_id);
                this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate, project_id);
            });
        }
    }

    public async get_mentions_graph(start, end, project_id) {
        this.mmapLoading = true;
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'mentions_map');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 50);
        formData.append("page_no", 0);
        formData.append("sentiment", this.sentiment);
        formData.append("country", this.country);
        formData.append("text_search", this.text_search);
        formData.append("channels[twitter]", this.checked_sm.twitter);
        formData.append("channels[facebook]", this.checked_sm.facebook);
        formData.append("channels[instagram]", this.checked_sm.instagram);
        formData.append("channels[web]", this.checked_sm.web);
        formData.append("channels[youtube]", this.checked_sm.youtube);
        formData.append("channels[reviews]", this.checked_sm.reviews);
        formData.append("channels[others]", this.checked_sm.others);
        formData.append("channels[all]", this.checked_sm.all);
        formData.append("project_id", project_id);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
            this.mmapLoading = false;
        } else {
            this.ChartDataSets.push({ id: project_id, data: this.result.data, label: this.result.project.name, borderWidth: 2, pointRadius: 0, lineTension: 0, backgroundColor: 'rgba(0, 0, 0, 0)', borderColor: this.lineChartColors[this.ChartDataSets.length], stacked: true });
            this.lineChartData = this.ChartDataSets;
            this.mmapLoading = false;
        }
    }

    public async compare_projects() {
        const { value: pjt } = await Swal.fire({
            title: 'Projects',
            input: 'select',
            customClass: {
                container: 'compare_popup'
            },
            inputOptions: this.projects,
            inputPlaceholder: 'Select a Project',
            showCancelButton: true,
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    if (value === '') {
                        resolve('Please select a project')
                    } else {
                        resolve();
                    }
                })
            }
        });

        if (pjt) {
            this.compare.push(pjt);
            this.get_projects();
            this.get_mentions_graph(this.selected.startDate, this.selected.endDate, pjt);
            this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate, pjt);
        }
    }

    public async get_projects() {
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("exclude_pjt", this.compare);

        this.result = await this.service.form_actions(formData, 'project_options');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.projects = this.result.data;
        }
    }

    public async get_mentions_per_sm(start, end, project_id) {
        this.spinner.show();
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'count_per_sm');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 10);
        formData.append("sentiment", this.sentiment);
        formData.append("country", this.country);
        formData.append("project_id", project_id);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            this.spinner.hide();
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.get_doughnut_chart(project_id, this.result.project, this.result.data);
            this.spinner.hide();
        }
    }

    public get_doughnut_chart(project_id, project, data) {
        var chart_data = [];
        var colours = [];
        var labels = [];
        if (data.web != 'denied') {
            labels.push('Web');
            chart_data.push(data.web);
            colours.push('#4392B7');
        }
        if (data.twitter != 'denied') {
            labels.push('Twitter');
            chart_data.push(data.twitter);
            colours.push('#37A9F3');
        }
        if (data.instagram != 'denied') {
            labels.push('Instagram');
            chart_data.push(data.instagram);
            colours.push('#F7C050');
        }
        if (data.facebook != 'denied') {
            labels.push('Facebook');
            chart_data.push(data.facebook);
            colours.push('#4867AA');
        }
        if (data.youtube != 'denied') {
            labels.push('Youtube');
            chart_data.push(data.youtube);
            colours.push('#FF4A4A');
        }
        if (data.reviews != 'denied') {
            labels.push('Reviews');
            chart_data.push(data.reviews);
            colours.push('#038c99');
        }
//        if (data.others != 'denied') {
//            labels.push('Others');
//            chart_data.push(data.others);
//            colours.push('#f47424');
//        }
        if (data.others != 'denied') {
            labels.push('Linkedin');
            chart_data.push(data.linkedin);
            colours.push('#0077b5');
        }
        if (data.others != 'denied') {
            labels.push('Others');
            chart_data.push(data.reddit);
            colours.push('#FF4500');
        }
        //    this.doughnutChartColors = [{backgroundColor: backgroundColor}];
        //    this.doughnutChartData = [chart_data];

        this.sourcesDoughnutChart.push({
            id: project_id,
            project: project,
            source_data: { labels: labels, data: chart_data, colours: [{ backgroundColor: colours }] },
            sentiment_data: [this.result.data.positive, this.result.data.negative],
            count: { all: this.result.data.all, positive: this.result.data.positive, negative: this.result.data.negative }
        });
    }

    public remove_chart(project_id) { //console.log(this.sourcesDoughnutChart);
        this.ChartDataSets.forEach((values, index) => {
            if (values.id == project_id) { //console.log(values.id);
                this.ChartDataSets.splice(index, 1);
            }
        });
        this.sourcesDoughnutChart.forEach((values, index) => {
            if (values.id == project_id) { //console.log(values.id);
                this.sourcesDoughnutChart.splice(index, 1);
            }
        });
        this.compare.forEach((value, index) => {
            if (value == project_id) {
                this.compare.splice(index, 1);
                this.get_projects();
            }
        });
        //console.log(this.sourcesDoughnutChart);
    }

}
